export default {
  init() {

    this.animateOnScroll = this.animateOnScroll.bind( this );
    this.halfInnerHeight = window.innerHeight / 2 + window.innerHeight / 1.75;

    this.animateOnScroll();

    document.addEventListener( 'scroll', this.animateOnScroll );

  },

  animateOnScroll()
  {

    const animate = document.querySelectorAll( '[ data-animate ], [ data-animate-left ], [ data-animate-right ], [ data-animate-up ], [ data-animate-down ], [ data-animate-reveal ]' );

    if ( animate.length == 0 ) {
      return;
    }

    if ( !animate[0].classList.contains( 'is-shown' ) ) {
      animate[0].classList.add( 'is-shown' );
      $( animate[0] ).parents( 'section' )[0].classList.add( 'is-in' );
    }

    if ( animate.length > 1 && !$( 'body' ).hasClass( 'home' ) && !animate[1].classList.contains( 'is-shown' ) ) {
      animate[1].classList.add( 'is-shown' );
      $( animate[1] ).parents( 'section' )[0].classList.add( 'is-in' );
    }

    Object.keys( animate ).map( ( index ) => {

      const el = animate[ index ];
      const elOffset = $( el ).offset().top;

      const section = $( el ).parents( 'section' )[0]
      const sectionOffset = $( section ).offset().top;

      if ( window.pageYOffset + this.halfInnerHeight >= elOffset && !el.classList.contains( 'is-shown' ) ) {
        el.classList.add( 'is-shown' )
      }

      if ( window.pageYOffset + this.halfInnerHeight >= sectionOffset && !section.classList.contains( 'is-in' ) ) {
        section.classList.add( 'is-in' )
      }
    });

  },
}



// WEBPACK FOOTER //
// ./scripts/modules/animation.js